import * as z from 'zod'

import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'

import {GenericCTAGroupSchema} from './generic-cta-group'

export const GenericConditionalCTAsSchema = buildEntrySchemaFor('genericConditionalCtas', {
  fields: z.lazy(() =>
    z.object({
      default: GenericCTAGroupSchema,
      isLoggedIn: safeOptional(GenericCTAGroupSchema),
      hasCopilot: safeOptional(GenericCTAGroupSchema),
      hasCopilotPaid: safeOptional(GenericCTAGroupSchema),
      hasCopilotPro: safeOptional(GenericCTAGroupSchema),
      hasOrganization: safeOptional(GenericCTAGroupSchema),
    }),
  ),
})

export type GenericConditionalCTAs = z.infer<typeof GenericConditionalCTAsSchema>
